import { InitialHealthStatusEntry, Tierart } from '@ps20/bff-models';
import { HealthStatusList } from '../store/model/healthStatus';

export function filterHealthStatusListForAnimalType(
  animalType: Tierart,
  healthStatusList: HealthStatusList,
): InitialHealthStatusEntry[] {
  if (!healthStatusList) {
    return [];
  }
  const { horse = [], dogCat = [] } = healthStatusList || ({} as HealthStatusList);
  return animalType === Tierart.VRPFERD ? horse || [] : dogCat || [];
}
